import { ReceiptLong, Route, StorefrontOutlined } from '@mui/icons-material';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AirlineSeatReclineExtraIcon from '@mui/icons-material/AirlineSeatReclineExtra';
import ArticleIcon from '@mui/icons-material/Article';
import BusinessIcon from '@mui/icons-material/Business';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import GarageIcon from '@mui/icons-material/Garage';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from '@mui/icons-material/Place';
import PsychologyRoundedIcon from '@mui/icons-material/PsychologyRounded';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import ShareLocationOutlinedIcon from '@mui/icons-material/ShareLocationOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import { Box, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { FileText } from 'lucide-react';
import { FC, memo } from 'react';

import ServiceEndNotice from './ServiceEndNotice.component';

type Props = {
  navigateToKpis: () => void;
  handlePlanningMenuOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  planningMenuAnchorEl: null | HTMLElement;
  handlePlanningMenuOnClose: () => void;
  navigateToPlanningMap: () => void;
  navigateToMap: () => void;
  navigateToPlanningTimeline: () => void;
  navigateToConvenienceDispatches: () => void;
  navigateToPlanningLane: () => void;
  navigateToOrders: () => void;
  handleSettingMenuOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  settingMenuAnchorEl: null | HTMLElement;
  handleSettingMenuOnClose: () => void;
  navigateToCourses: () => void;
  navigateToContracts: () => void;
  navigateToGarages: () => void;
  navigateToPartnerCompanies: () => void;
  navigateToTrucks: () => void;
  navigateToGroups: () => void;
  navigateToDrivers: () => void;
  navigateToPlaces: () => void;
  navigateToProducts: () => void;
  navigateToAreas: () => void;
  useOutsourcingContractPdf: boolean;
  navigateToOutsourcingContractSettings: () => void;
  navigateToConfig: () => void;
  handleAccountMenuOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  accountMenuAnchorEl: null | HTMLElement;
  handleAccountMenuOnClose: () => void;
  navigateToAccounts: () => void;
  isAdmin: () => boolean;
  navigateToCompany: () => void;
  logout: () => void;
  useTrunkTransportation: boolean;
  navigateToPlanningTrunkTransportation: () => void;
  /** 長距離配車。出し分けは幹線輸送と同じ useTrunkTransportation を流用する */
  navigateToLongHaul: () => void;
  useLogForSales: boolean;
  navigateToSalesOrders: () => void;
  navigateToShipmentOrders: () => void;
  navigateToShipmentOrderLegs: () => void;
  appEnv: string;
  navigateToPerformanceManagement: () => void;
  useDispatchTableImport?: boolean;
  navigateToDispatchTableImport: () => void;
}

const AppBarSmMenuComponent: FC<Props> = memo((
  {
    navigateToKpis,
    handlePlanningMenuOnClick,
    planningMenuAnchorEl,
    handlePlanningMenuOnClose,
    navigateToPlanningMap,
    navigateToMap,
    navigateToPlanningTimeline,
    navigateToConvenienceDispatches,
    navigateToPlanningLane,
    navigateToOrders,
    handleSettingMenuOnClick,
    settingMenuAnchorEl,
    handleSettingMenuOnClose,
    navigateToCourses,
    navigateToContracts,
    navigateToGarages,
    navigateToPartnerCompanies,
    navigateToTrucks,
    navigateToGroups,
    navigateToDrivers,
    navigateToPlaces,
    navigateToProducts,
    navigateToAreas,
    useOutsourcingContractPdf,
    navigateToOutsourcingContractSettings,
    navigateToConfig,
    handleAccountMenuOnClick,
    accountMenuAnchorEl,
    handleAccountMenuOnClose,
    navigateToAccounts,
    isAdmin,
    navigateToCompany,
    logout,
    useTrunkTransportation,
    navigateToPlanningTrunkTransportation,
    navigateToLongHaul,
    useLogForSales,
    navigateToSalesOrders,
    navigateToShipmentOrders,
    navigateToShipmentOrderLegs,
    appEnv,
    navigateToPerformanceManagement,
    useDispatchTableImport,
    navigateToDispatchTableImport,
  }
) => (
  <>
    <Box pl={3} sx={{ flexGrow: 1, display: 'flex' }}>
      <Tooltip title="案件管理">
        <IconButton
          onClick={
            () => {
              navigateToShipmentOrders();
            }
          }
        >
          <ReceiptIcon />
        </IconButton>
      </Tooltip>
      {/* <Tooltip title="実績参照">
        <IconButton
          onClick={
            () => {
              navigateToKpis();
            }
          }
        >
          <InsertChartOutlinedIcon />
        </IconButton>
      </Tooltip> */}
      <Tooltip title="配車計画">
        <IconButton
          onClick={
            handlePlanningMenuOnClick
          }
        >
          <ShareLocationOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="実績管理">
        <IconButton
          onClick={
            () => {
              navigateToPerformanceManagement();
            }
          }
        >
          <InsertChartOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="appbar-planning-menu"
        anchorEl={planningMenuAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(planningMenuAnchorEl)}
        onClose={handlePlanningMenuOnClose}
        MenuListProps={{ sx: { p: 0, m: 0, } }}
      >
        <ServiceEndNotice>
          <MenuItem
            onClick={
              () => {
                navigateToPlanningMap();
              }
            }
          >
            <ShareLocationOutlinedIcon
              sx={{
                mr: 1
              }}
            />
            マップ (旧)
          </MenuItem>
        </ServiceEndNotice>
        <MenuItem
          onClick={
            () => {
              navigateToMap();
            }
          }
        >
          <ShareLocationOutlinedIcon
            sx={{
              mr: 1
            }}
          />
          マップ
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToPlanningTimeline();
            }
          }
        >
          <ViewTimelineIcon
            sx={{
              mr: 1
            }}
          />
          タイムライン
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToConvenienceDispatches();
            }
          }
        >
          <StorefrontOutlined
            sx={{
              mr: 1
            }}
          />
          カード
        </MenuItem>
        {useTrunkTransportation && (
          <MenuItem
            onClick={
              () => {
                navigateToLongHaul();
              }
            }
          >
            <LocalShippingOutlinedIcon
              sx={{
                mr: 1
              }}
            />
            長距離配車
          </MenuItem>
        )}
        <MenuItem
          onClick={
            () => {
              navigateToPlanningLane();
            }
          }
        >
          <Route
            sx={{
              mr: 1
            }}
          />
          レーン管理
        </MenuItem>
        {useDispatchTableImport && (
          <MenuItem
            onClick={() => {
              navigateToDispatchTableImport();
            }}
          >
            <UploadFileOutlinedIcon sx={{ mr: 1 }} />
            配車表取込
          </MenuItem>
        )}
        {/* <Stack direction="row" alignItems="center">
          <MenuItem
            onClick={
              () => {
                navigateToPlanningTrunkTransportation();
              }
            }
            disabled={!useTrunkTransportation}
          >
            <DirectionsIcon
              sx={{
                mr: 1
              }}
            />
            幹線輸送
          </MenuItem>
          {!useTrunkTransportation && (
            <Tooltip
              title="幹線輸送機能を利用したい場合はセールス (sales@logpose.co.jp) へご連絡ください。"
            >
              <HelpOutline />
            </Tooltip>
          )}
        </Stack> */}
      </Menu>
      {/* <Tooltip title="案件一覧">
        <IconButton
          onClick={
            () => {
              navigateToOrders();
            }
          }
        >
          <BallotIcon />
        </IconButton>
      </Tooltip> */}
      {/* <Tooltip title="配車一覧">
        <IconButton
          onClick={
            () => {
              navigateToShipmentOrderLegs();
            }
          }
        >
          <AssignmentIcon />
        </IconButton>
      </Tooltip> */}
      {(appEnv !== 'prd') && (
        <Tooltip title="受注一覧">
          <IconButton
            onClick={
              () => {
                navigateToSalesOrders();
              }
            }
            disabled={!useLogForSales}
          >
            <ReceiptLong />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="設定">
        <IconButton
          onClick={
            handleSettingMenuOnClick
          }
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="appbar-setting-menu"
        anchorEl={settingMenuAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(settingMenuAnchorEl)}
        onClose={handleSettingMenuOnClose}
        MenuListProps={{ sx: { p: 0, m: 0, } }}
      >
        <MenuItem onClick={() => { navigateToCourses(); }}>
          <RouteOutlinedIcon sx={{ mr: 1 }} />
          ダイヤ・コースマスタ
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToContracts();
            }
          }
        >
          <FileText
            size={24}
            style={{
              marginRight: 8
            }}
          />
          契約管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToGarages();
            }
          }
        >
          <GarageIcon
            sx={{
              mr: 1
            }}
          />
          車庫管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToPartnerCompanies();
            }
          }
        >
          <GroupsIcon
            sx={{
              mr: 1
            }}
          />
          運送会社管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToTrucks();
            }
          }
        >
          <DirectionsCarIcon
            sx={{
              mr: 1
            }}
          />
          車両管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToGroups();
            }
          }
        >
          <GroupIcon
            sx={{
              mr: 1
            }}
          />
          車両グループ管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToDrivers();
            }
          }
        >
          <AirlineSeatReclineExtraIcon
            sx={{
              mr: 1
            }}
          />
          ドライバー管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToAreas();
            }
          }
        >
          <FolderCopyIcon
            sx={{
              mr: 1
            }}
          />
          エリア管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToPlaces();
            }
          }
        >
          <PlaceIcon
            sx={{
              mr: 1
            }}
          />
          地点管理
        </MenuItem>
        <MenuItem
          onClick={
            () => {
              navigateToProducts();
            }
          }
        >
          <Inventory2Icon
            sx={{
              mr: 1
            }}
          />
          商品管理
        </MenuItem>
        {(useOutsourcingContractPdf && (
          <MenuItem
            onClick={
              () => {
                navigateToOutsourcingContractSettings();
              }
            }
          >
            <ArticleIcon
              sx={{
                mr: 1
              }}
            />
            委託表設定
          </MenuItem>
        ))}
        <MenuItem
          onClick={
            () => {
              navigateToConfig();
            }
          }
        >
          <PsychologyRoundedIcon
            sx={{
              mr: 1
            }}
          />
          システム設定
        </MenuItem>
      </Menu>
    </Box>
    <Box>
      <IconButton
        onClick={handleAccountMenuOnClick}
      >
        <AccountCircleRoundedIcon />
      </IconButton>
    </Box>
    <Menu
      id="appbar-account-menu"
      anchorEl={accountMenuAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(accountMenuAnchorEl)}
      onClose={handleAccountMenuOnClose}
      MenuListProps={{ sx: { p: 0, m: 0, } }}
    >
      <MenuItem
        onClick={
          () => {
            navigateToAccounts();
          }
        }
      >
        <PersonIcon
          sx={{
            mr: 1
          }}
        />
        アカウント管理
      </MenuItem>
      {
        isAdmin() && (
          <MenuItem
            onClick={
              () => {
                navigateToCompany();
              }
            }
          >
            <BusinessIcon
              sx={{
                mr: 1
              }}
            />
            会社情報
          </MenuItem>
        )
      }
      <MenuItem
        onClick={
          () => {
            logout();
          }
        }
      >
        <LogoutRoundedIcon
          sx={{
            mr: 1
          }}
        />
        ログアウト
      </MenuItem>
    </Menu>
  </>
));

export default AppBarSmMenuComponent;
